import { createPortal } from "react-dom";
import Div from "../Div"; 
import FormButton from "../FormButton";
import { useEffect, useState, useCallback } from "react";
import { getMeetingDataHttp } from "../../http/renewalHttp/RenewalHttp";

export default function ViewMeetingDataModal({ customer_data, handleClicked }) {
    const [meetings, setMeetings] = useState([]);
    const [loading, setLoading] = useState(true);

    const fetchMeetings = useCallback(async () => {
        const response = await getMeetingDataHttp(customer_data.customerDomain);
        if (response && response.meetings) {
            setMeetings(response.meetings);
        }
        setLoading(false);
    }, [customer_data.customerDomain]);

    useEffect(() => {
        fetchMeetings();
    }, [fetchMeetings]);

    return createPortal(
        <Div className="modal-backdrop">
            <dialog open style={{ zIndex: '1', margin: 'auto', padding: '20px', width: '800px', maxWidth: '90%' }}>
                <Div className="modal-content">
                    <h5>Meeting History: {customer_data.customerDomain}</h5>
                    <hr />
                    {loading ? <p>Loading...</p> : (
                        meetings.length > 0 ? (
                            <div className="table-responsive" style={{maxHeight: '400px'}}>
                                <table className="table table-bordered table-sm">
                                    <thead>
                                        <tr>
                                            <th>Date</th>
                                            <th>Type</th>
                                            <th>Product</th>
                                            <th>Count</th>
                                            <th>Adoption</th>
                                            <th>Rating</th>
                                            <th>Feedback</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {meetings.map((m, i) => (
                                            <tr key={i}>
                                                <td>{m.timestamp.split('T')[0]}</td>
                                                <td>{m.meeting_type}</td>
                                                <td>{m.new_opps_product}</td>
                                                <td>{m.new_opps_count}</td>
                                                <td>{m.adoption}</td>
                                                <td>{m.support_rating}</td>
                                                <td>{m.feedback}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        ) : <p className="text-danger">Data Not Found</p>
                    )}
                    <Div className="d-flex justify-content-end mt-3">
                        <FormButton className="btn btn-secondary" onClick={() => handleClicked(false)}>Close</FormButton>
                    </Div>
                </Div>
            </dialog>
        </Div>,
        document.getElementById('modal')
    );
}